export default __webpack_public_path__ + "static/media/ig.e395727e.svg";